<template>
  <BackgroundImage
    v-if="src && srcset"
    :image-class="imageClass"
    :src="src"
    :srcset="srcset.length > 1 ? srcset.join(', ') : undefined"
    :low-src="lowSrc ?? undefined"
    :lazy="lazy"
    :alt="image?.alt ?? ''"
    :size="size"
    :copyright="noCopyright ? undefined : image?.copyright"
  />
</template>

<script lang="ts" setup>
import type { GQLImage } from '@core/types/generated/image'

const props = withDefaults(
  defineProps<{
    image: GQLImage | null
    lazy?: boolean
    size?: 'cover' | 'contain'
    imageClass?: string
    noCopyright?: boolean
  }>(),
  { lazy: true, size: 'cover' },
)

const lowSrc = computed(() => {
  return props.image && props.lazy ? getLowSrc(props.image) : undefined
})

const srcset = computed(() => {
  return props.image ? getSrcset(props.image) : undefined
})
const src = computed(() => srcset.value?.[0]?.split(' ')[0])
</script>
